export function LiveScheduleSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/live-schedule.svg'"></ng-include>`
    }
}